import { Box, useMediaQuery, useTheme } from '@mui/material';
import { ChatClient } from '../../components/chat-system/ChatClient';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState, useCallback } from 'react';
import { useChatClient } from '../../components/chat-system/useChatClient';

const Chat = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [searchParams] = useSearchParams();
  const { conversations, setSelectedConversation } = useChatClient();
  const conversationId = searchParams.get('conversation');
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);

  // Update viewport height on resize/orientation change
  const updateViewportHeight = useCallback(() => {
    setViewportHeight(window.innerHeight);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', updateViewportHeight);
    window.addEventListener('orientationchange', () => {
      // Delay to allow browser to complete orientation change
      setTimeout(updateViewportHeight, 100);
    });

    return () => {
      window.removeEventListener('resize', updateViewportHeight);
      window.removeEventListener('orientationchange', updateViewportHeight);
    };
  }, [updateViewportHeight]);

  // Auto-select conversation from URL parameter
  useEffect(() => {
    if (conversationId && conversations.length > 0) {
      const conversation = conversations.find(c => c.id === parseInt(conversationId));
      if (conversation) {
        setSelectedConversation(conversation);
      }
    }
  }, [conversationId, conversations, setSelectedConversation]);

  // Mobile: use calculated height to avoid page scroll
  if (isMobile) {
    const topbarHeight = 44;
    const mobileMenuHeight = 35;
    const chatHeight = viewportHeight - topbarHeight - mobileMenuHeight;

    return (
      <Box
        sx={{
          position: 'fixed',
          top: topbarHeight,
          left: 0,
          right: 0,
          height: chatHeight,
          overflow: 'hidden',
          zIndex: 10,
        }}
      >
        <ChatClient />
      </Box>
    );
  }

  return (
    <Box className="md:pt-[43px] h-full w-full flex flex-col overflow-hidden">
      <ChatClient />
    </Box>
  );
};

export default Chat;
